import React from 'react'
import './ServicesOverviewSection.css';
export default function ServicesOverviewSection({ title, description, image, altText }) {
  return (
   <>
   
   <section className="overview-section">
      <div className="overview-container">
        <div className="overview-text">
          <h2 className="overview-title">{title}</h2>
          <p className="overview-description">{description}</p>
        </div>
        {/* <div className="overview-image">
          <img src={image} alt={altText} className="overview-img" />
        </div> */}
      </div>
    </section>
   
   
   
   
   
   
   
   
   </>
  )
}
